/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Rows_MilestoneInputs */

const en_tl_rows_milestone = /** @type {(inputs: Tl_Rows_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milestones`)
};

const de_tl_rows_milestone = /** @type {(inputs: Tl_Rows_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilensteine`)
};

/**
* | output |
* | --- |
* | "Milestones" |
*
* @param {Tl_Rows_MilestoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_rows_milestone = /** @type {((inputs?: Tl_Rows_MilestoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Rows_MilestoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_rows_milestone(inputs)
	return en_tl_rows_milestone(inputs)
});